import { useHistory } from 'react-router-dom';
import { defineFooterUrl } from 'utils/paths';

export function useStepsWizard({ naId, isExternalAccess, accessKey, preview }) {
  const history = useHistory();

  const goToStep = ({ step, replace = false }) => {
    const url = defineFooterUrl(isExternalAccess, step, naId, accessKey, preview);

    replace ? history.replace(url) : history.push(url);
  };

  return { goToStep };
}
